import CrmDashboardAPI from '../../api/crmDashboard';
import {
  apiParamsWithoutCacheControl,
  readCrmCache,
  shouldBypassCrmCache,
  writeCrmCache,
} from '../../helper/crmCache';

const CACHE_TTL = 60 * 1000;

const MUTATIONS = {
  SET_METRICS:    'CRM_DASHBOARD_SET_METRICS',
  SET_STATS:      'CRM_DASHBOARD_SET_STATS',
  SET_FETCHING:   'CRM_DASHBOARD_SET_FETCHING',
  SET_ERROR:      'CRM_DASHBOARD_SET_ERROR',
};

const state = {
  metrics: {},
  stats: {},
  uiFlags: {
    isFetching: false,
  },
  error: null,
};

const getters = {
  getDashboardMetrics: $state => $state.metrics,
  getDashboardStats:   $state => $state.stats,
  getDashboardUIFlags: $state => $state.uiFlags,
};

const actions = {
  // Fetches today's card metrics from /rankings/today_metrics
  fetchMetrics: async ({ commit }, params = {}) => {
    const apiParams = apiParamsWithoutCacheControl(params);
    const cached = shouldBypassCrmCache(params)
      ? null
      : readCrmCache('crmDashboard.metrics', apiParams, CACHE_TTL);

    if (cached) {
      commit(MUTATIONS.SET_METRICS, cached);
      return;
    }

    commit(MUTATIONS.SET_FETCHING, true);
    commit(MUTATIONS.SET_ERROR, null);
    try {
      const { data } = await CrmDashboardAPI.getTodayMetrics(apiParams);
      commit(MUTATIONS.SET_METRICS, data);
      writeCrmCache('crmDashboard.metrics', apiParams, data);
    } catch (error) {
      commit(MUTATIONS.SET_ERROR, error.message);
    } finally {
      commit(MUTATIONS.SET_FETCHING, false);
    }
  },

  fetchAdvancedStats: async ({ commit }, params = {}) => {
    const apiParams = apiParamsWithoutCacheControl(params);
    const cached = shouldBypassCrmCache(params)
      ? null
      : readCrmCache('crmDashboard.advancedStats', apiParams, CACHE_TTL);

    if (cached) {
      commit(MUTATIONS.SET_STATS, cached);
      return;
    }

    commit(MUTATIONS.SET_FETCHING, true);
    commit(MUTATIONS.SET_ERROR, null);
    try {
      const { data } = await CrmDashboardAPI.getAdvancedStats(apiParams);
      const stats = data.stats ?? data;
      commit(MUTATIONS.SET_STATS, stats);
      writeCrmCache('crmDashboard.advancedStats', apiParams, stats);
    } catch (error) {
      commit(MUTATIONS.SET_ERROR, error.message);
    } finally {
      commit(MUTATIONS.SET_FETCHING, false);
    }
  },
};

const mutations = {
  [MUTATIONS.SET_METRICS]($state, metrics) {
    $state.metrics = metrics;
  },
  [MUTATIONS.SET_STATS]($state, stats) {
    $state.stats = stats;
  },
  [MUTATIONS.SET_FETCHING]($state, value) {
    $state.uiFlags.isFetching = value;
  },
  [MUTATIONS.SET_ERROR]($state, error) {
    $state.error = error;
  },
};

export default { state, getters, actions, mutations };
